import { request } from "../client"

export type DailyBriefingSettings = {
  organization_id: string
  enabled: boolean
  send_time: string
  planning_lead_days: 7 | 14 | 21 | 28
  timezone: string
  active_from: string
}
export type DailyBriefingSendResult = { delivery_request_id: string }
export const fetchDailyBriefingSettings = (organizationId: string, signal?: AbortSignal) =>
  request<DailyBriefingSettings>(`/daily-briefing/${organizationId}`, { signal })
export const updateDailyBriefingSettings = (
  organizationId: string,
  payload: Pick<DailyBriefingSettings, "enabled" | "send_time" | "planning_lead_days">,
) =>
  request<DailyBriefingSettings>(`/daily-briefing/${organizationId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  })
export const sendDailyBriefing = (
  organizationId: string,
  recipientMembershipId: string,
  idempotencyKey: string,
  signal?: AbortSignal,
  referenceDate?: string,
) =>
  request<DailyBriefingSendResult>(`/daily-briefing/${organizationId}/send`, {
    method: "POST",
    headers: { "Idempotency-Key": idempotencyKey },
    body: JSON.stringify({
      recipient_membership_id: recipientMembershipId,
      reference_date: referenceDate,
    }),
    signal,
  })
